import { AUTH_TYPE } from '~/constants/auth'
import { ADMIN_ROUTES } from '~/constants/router'

export const REDIRECT_PARAM = 'redirect'

// Only these exact paths may be used as a post-login redirect target
export const REDIRECT_BACK_ALLOWLIST: string[] = [
  ADMIN_ROUTES.DOWNLOAD_KIOSK_APP,
]

const stripTrailingSlash = (path: string): string =>
  path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path

const matchAllowlist = (path?: string | null): string | null => {
  if (!path) return null
  const normalized = stripTrailingSlash(path)
  return REDIRECT_BACK_ALLOWLIST.includes(normalized) ? normalized : null
}

export const getSafeRedirect = (search: string): string | null =>
  matchAllowlist(new URLSearchParams(search || '').get(REDIRECT_PARAM))

export const isRedirectBackPath = (pathname: string): boolean =>
  matchAllowlist(pathname) !== null

const withRedirect = (base: string, pathname?: string): string => {
  const target = matchAllowlist(pathname)
  return target
    ? `${base}?${REDIRECT_PARAM}=${encodeURIComponent(target)}`
    : base
}

export const buildLoginUrl = (pathname?: string): string =>
  withRedirect(AUTH_TYPE.SIGN_IN, pathname)

export const buildLogoutUrl = (pathname?: string): string =>
  withRedirect(ADMIN_ROUTES.LOGOUT, pathname)
